import { useState } from 'react';

type UseMultipleLoadingReturn<T> = [(...filterLoadings: T[]) => boolean, (loading: T) => void]

export const useMultipleLoading = <T extends string>(...loadings: T[]): UseMultipleLoadingReturn<T> => {
  const loadingsMap = loadings.reduce<GenericMap<boolean>>((map, loading) => ({ ...map, [loading]: false }), {});

  const [loadingsState, setLoadingsState] = useState(loadingsMap);

  const loaded = (...filterLoadings: T[]) => {
    return Object.keys(loadingsState)
      .filter((loadingKey) => (filterLoadings.length > 0 ? filterLoadings.includes(loadingKey as T) : true))
      .every(loadingKey => loadingsState[loadingKey] === true);
  };

  const setCompleted = (loading: string) => {
    setLoadingsState(completed => ({ ...completed, [loading]: true }));
  };

  return [loaded, setCompleted];
};
